import { authStore } from "@/store/auth-store";
import moment from "moment";
import {
  momentDateFormat,
  slashedDateFormat,
  momentDateTimeFormat,
  slashedDateTimeFormat,
} from "../utils/consts";
import {
  baseDomain,
  orikomiDomain,
  orikomiDomainStorage,
  paymentDomain,
  clientManagementDomain,
  storageDomain,
  systemName,
} from "../utils/baseConsts";

export default (function () {
  const domain = baseDomain; // "csv3.107.jp"
  const domainClient = orikomiDomain; // "csv3.107.jp"
  const backendApiDomain = baseDomain + "/api";
  const storageApiDomain = storageDomain + "/api";
  const backendClientApiDomain = domainClient + "/api";
  const orikomiApiDomain = orikomiDomain + "/api";
  const orikomiApiDomainStorage = orikomiDomainStorage + "/api";
  const paymentApiDomain = paymentDomain + "/api";
  const clientManagementApiDomain = clientManagementDomain + "/api";

  const backendWebSocketDomain = domain + ":9001";

  const fetchCoreClient = async (
    subPath,
    reqBody,
    outputObj = false,
    outputJson = true,
    cancelToken = false
  ) => {
    return fetchCore(
      backendClientApiDomain,
      subPath,
      reqBody,
      outputObj,
      outputJson,
      cancelToken
    );
  };

  const fetchCorePosting = async (
    subPath,
    reqBody,
    outputObj = false,
    outputJson = true,
    cancelToken = false
  ) => {
    return fetchCore(
      backendApiDomain,
      subPath,
      reqBody,
      outputObj,
      outputJson,
      cancelToken
    );
  };
  const fetchCoreStorage = async (
    subPath,
    reqBody,
    outputObj = false,
    outputJson = true,
    cancelToken = false
  ) => {
    return fetchCore(
      storageApiDomain,
      subPath,
      reqBody,
      outputObj,
      outputJson,
      cancelToken
    );
  };

  const fetchCoreOrikomi = async (
    subPath,
    reqBody,
    outputObj = false,
    outputJson = true,
    cancelToken = false
  ) => {
    return fetchCore(
      orikomiApiDomain,
      subPath,
      reqBody,
      outputObj,
      outputJson,
      cancelToken
    );
  };
  const fetchCoreOrikomiStorage = async (
    subPath,
    reqBody,
    outputObj = false,
    outputJson = true,
    cancelToken = false
  ) => {
    return fetchCore(
      orikomiApiDomainStorage,
      subPath,
      reqBody,
      outputObj,
      outputJson,
      cancelToken
    );
  };

  const fetchCorePayment = async (
    subPath,
    reqBody,
    outputObj = false,
    outputJson = true,
    cancelToken = false
  ) => {
    return fetchCore(
      paymentApiDomain,
      subPath,
      reqBody,
      outputObj,
      outputJson,
      cancelToken
    );
  };

  const fetchCoreClientManagement = async (
    subPath,
    reqBody,
    outputObj = false,
    outputJson = true,
    cancelToken = false
  ) => {
    return fetchCore(
      clientManagementApiDomain,
      subPath,
      reqBody,
      outputObj,
      outputJson,
      cancelToken
    );
  };

  const fetchCore = async (
    baseDomainClient,
    subPath,
    reqBody,
    outputObj = false,
    outputJson = true,
    cancelToken = false
  ) => {
    if (
      !authStore.getters.isAuthorized &&
      subPath !== "/v1/login" &&
      subPath !== "/v1/client/forget_password" &&
      subPath !== "/v1/client/init_register"
    ) {
      return "auth and subpath";
    }

    const opts = {
      headers: {
        "Content-Type": "application/json",
        Authorization: authStore.state.token,
      },
      method: "POST",
    };

    if (reqBody) {
      opts.body = JSON.stringify(reqBody);
    }

    const resp = await fetch(baseDomainClient + subPath, opts);

    //Expired Token  //Wrong Token の場合はログインページに遷移

    if (!cancelToken) {
      if (resp.headers.get("Authorization")) {
        authStore.commit("updateToken", resp.headers.get("Authorization"));
      }
    }

    if (outputJson) {
      const jsonObj = await resp.json();
      if (
        jsonObj.error_message == "Expired Token" ||
        jsonObj.error_message == "Wrong Token" ||
        jsonObj.description == "expired token"
      ) {
        authStore.commit("updateToken", "");
        location.href = "/login";
      }
      return jsonObj;
    }

    const bodyText = await resp.text();

    if (bodyText.length === 0) {
      return null;
    }

    const bodyObj = JSON.parse(bodyText);

    return bodyObj;
  };

  const forgotPassword = async (userIdMail) => {
    const obj = {
      user_id: userIdMail,
      cart_system_id: 2,
    };
    return fetchCoreClientManagement("/v1/client/forget_password", obj);
  };

  const tryLogin = async (
    userId,
    password,
    baseUrl,
    callbackUrl,
    returnUrl,
    cartSystemId,
    storeUrl
  ) => {
    const obj = {
      user_id: userId,
      password: password,
      base_url: baseUrl,
      callback_url: callbackUrl,
      return_url: returnUrl,
      cart_system_id: cartSystemId,
      store_url: storeUrl,
    };
    return fetchCoreClientManagement("/v1/login", obj);
  };

  const refCartGroupBy = async () => {
    return fetchCorePosting("/v1/plan/2d_per_group");
  };

  const refCartGroupByOrikomi = async () => {
    //  return fetchCoreOrikomi("/v1/cart/ref_group_by")
    return fetchCoreOrikomi("/v1/plan/2d_per_group");
  };

  const allMenuList = async () => {
    return fetchCorePosting("/v1/all_menu_list");
  };
  /*
    const refOrderLimit = async(limit,postingStatus = -1) => {
        const obj = {
            limit : limit,
            posting_status : postingStatus
        }
        return fetchCore("/v2/order/ref_limit",obj)
    }*/

  const refOrderLimitGroupBy = async (
    limit,
    status,
    printing_status,
    orderKey,
    refText,
    fromTime,
    toTime
  ) => {
    const obj = {
      limit: limit,
      status: status,
      printing_status,
      order_key: orderKey,
      ref_text: refText,
      from_time: fromTime,
      to_time: toTime,
    };
    return fetchCorePosting("/v1/order/search_2d_per_group", obj);
  };

  const refOrderLimitGroupByOrikomi = async (
    limit,
    status,
    orderKey,
    refText,
    fromTime,
    toTime
  ) => {
    const obj = {
      limit: limit,
      status: status,
      order_key: orderKey,
      ref_text: refText,
      from_time: fromTime,
      to_time: toTime,
    };
    return fetchCoreOrikomi("/v1/order/search_2d_per_group", obj);
  };

  const refOrderFileName = async (orderKey) => {
    const obj = {
      order_key: orderKey,
      system_name: systemName,
    };
    return fetchCoreStorage("/v1/order/media_name", obj);
  };

  const refOrderFileNameOrikomi = async (orderKey) => {
    const obj = {
      order_key: orderKey,
    };
    return fetchCoreOrikomiStorage("/v1/order/media_name", obj);
  };

  const uploadOrderFileOrikomi = async (orderKey, fileName, fileData) => {
    const obj = {
      order_key: orderKey,
      file_name: fileName,
      file_data: fileData,
    };
    return fetchCoreOrikomi("/api/v1/order/upload_media", obj);
  };
  const orderReceive = async (
    planKey,
    dataType,
    paymentMethod,
    convenienceCode
  ) => {
    /*
        *
        * 00001	ローソン
00002	ファミリーマート
00005	ミニストップ
00006	デイリーヤマザキ
00007	セブンイレブン
00008	セイコーマート
        *
        * */
    // paymentMethod = 'cvs'

    // let cvsNumber = ''
    // cvsNumber = '00007'
    // if (paymentMethod == 'seven-eleven') {
    //   paymentMethod = 'cvs'
    //   cvsNumber = '00007'
    // } else if (paymentMethod == 'lawson') {
    //   paymentMethod = 'cvs'
    //   cvsNumber = '00001'
    // } else if (paymentMethod == 'secoma') {
    //   paymentMethod = 'cvs'
    //   cvsNumber = '00008'
    // }
    let obj = {};
    if (paymentMethod == "cvs") {
      obj = {
        plan_key: planKey,
        payment_method: paymentMethod,
        convenience_code: convenienceCode,
      };
    } else {
      obj = {
        plan_key: planKey,
        payment_method: paymentMethod,
      };
    }

    if (dataType == "posting" || dataType == "posting_and_print") {
      //   const obj = {
      //     plan_key: planKey,
      //     payment_method: paymentMethod,
      //     // convenience_code: cvsNumber,
      //     convenience_code: convenienceCode,
      //   }
      return fetchCorePosting("/v1/order/receive", obj);
    } else {
      //   const obj = {
      //     plan_key: planKey,
      //     payment_method: paymentMethod,
      //     // convenience_code: cvsNumber,
      //     convenience_code: convenienceCode,
      //   }
      return fetchCoreOrikomi("/v1/order/receive", obj);
    }
  };

  const refOnProcessOrders = async (onProcessType) => {
    const obj = {
      on_process_type: onProcessType,
    };
    return fetchCorePosting("/v2/order/ref_on_process_orders", obj);
  };

  const refOnProcessOrders2dArray = async (onProcessType) => {
    const obj = {
      on_process_type: onProcessType,
    };
    return fetchCorePosting("/v1/order/on_process_2d_per_group", obj);
  };

  const refOnProcessOrders2dArrayOrikomi = async (onProcessType) => {
    const obj = {
      on_process_type: onProcessType,
    };
    return fetchCoreOrikomi("/v1/order/on_process_2d_per_group", obj);
  };

  const refOrder = async (orderKey) => {
    const obj = {
      order_key: orderKey,
    };
    return fetchCorePosting("/v1/order/ref", obj);
  };

  const refOrderOrikomi = async (orderKey) => {
    const obj = {
      order_key: orderKey,
    };
    return fetchCoreOrikomi("/v1/order/ref", obj);
  };

  const accountList = async () => {
    const obj = {
      cart_system_id: 2,
      page: 1,
      limit: 1000,
    };
    return fetchCoreClientManagement("/v1/client/list");
  };
  const accountUpdate = async (account) => {
    return fetchCoreClientManagement("/v1/client/update", account);
  };

  const accountInsert = async (account) => {
    return fetchCoreClientManagement("/v1/client/add", account);
  };

  const accountDelete = async (account) => {
    return fetchCoreClientManagement("/v1/client/delete", account);
  };

  const myAccountInfo = async () => {
    return fetchCoreClientManagement("/v1/my_profile");
  };

  const myAccountInfoUpdate = async (accountInfo) => {
    return fetchCoreClientManagement("/v1/my_profile_update", accountInfo);
  };

  const myAccountFirstAddressUpdate = async (firstAddress) => {
    return fetchCoreClientManagement("/v1/client/address_update", firstAddress);
  };

  const myAccountPasswordUpdate = async (accountPassword) => {
    return fetchCoreClientManagement("/v1/password_update", accountPassword);
  };

  const registerCard = async (payload) => {
    return fetchCorePayment("/v1/register_card", payload);
  };

  const updateTrackingInfo = async (
    orderKey,
    destinationId,
    shippingCompany,
    tracking,
    dataType
  ) => {
    if (dataType == "posting") {
      const obj = {
        order_key: orderKey,
        destination_id: Number(destinationId),
        shipping_company: shippingCompany,
        tracking: tracking,
      };
      return fetchCorePosting("/v1/order/update_tracking", obj);
    } else if (dataType == "orikomi") {
      const obj = {
        order_key: orderKey,
        destination_id: Number(destinationId),
        shipping_company: shippingCompany,
        tracking: tracking,
      };
      return fetchCoreOrikomi("/v1/order/update_tracking", obj);
    }
  };

  const authorizePlans = async (groupId) => {
    const obj = {
      group_id: Number(groupId),
    };
    return fetchCorePosting("/v1/plan/authorize", obj);
  };

  const authorizePlansOrikomi = async (groupId) => {
    const obj = {
      group_id: Number(groupId),
    };
    return fetchCoreOrikomi("/v1/plan/authorize", obj);
  };

  //通常は、apiを叩くたびに、チェックがなされるが、mapは別プレジェクトであるため、mapに遷移する前にtokenの真正をチェックする
  const verifyToken = async () => {
    return fetchCorePosting("/v1/verify_token");
  };

  const planHistory = async () => {
    let fromDate = moment().utcOffset(9).add(-1, "years");
    //万一の時間の狂いを考慮して1時間先までの日付けとする
    let toDate = moment().utcOffset(9).add(1, "hours");

    const obj = {
      from_datetime: fromDate.format(slashedDateTimeFormat),
      to_datetime: toDate.format(slashedDateTimeFormat),
    };
    return fetchCorePosting("/v1/plan/history", obj);
  };

  const deleteCart = async (planKey, dataType) => {
    const obj = {
      plan_key: planKey,
    };

    if (dataType == "posting") {
      return fetchCorePosting("/v1/plan/delete", obj);
    } else {
      return fetchCoreOrikomi("/v1/plan/delete", obj);
    }
  };

  /* Payment relation */

  const payment = async (val) => {
    const obj = { amount: val };
    return fetchCorePayment("/v1/payment", obj);
  };

  const cancelPayment = async () => {
    const obj = {
      access_id: "d2834c3b1996353cca1e444dae959ad3",
      access_pass: "46ac32d4d174dbaceea9c33d2bca08e8",
    };
    return fetchCorePayment("/v1/cancel_payment", obj);
  };

  const getRegisterLink = async () => {
    return fetchCorePayment("/v1/card_link_to_register");
  };
  const registeredCheck = async () => {
    let account = await myAccountInfo();

    let mail = account.value.user_id;
    const obj = {
      user_id: mail,
    };
    return fetchCorePayment("/v1/check_registration", obj);
  };

  const registerInitUser = async (userObj) => {
    return fetchCoreClientManagement("/v1/client/init_register", userObj);
  };

  const registerUser = async (userObj) => {
    return await fetchCore(
      clientManagementApiDomain,
      "/v1/client/init_register",
      userObj
    );
  };

  const sendForgetPasswordMail = async (userIdMail) => {
    return await fetchCore(
      clientManagementApiDomain,
      "/v1/client/forget_password",
      {
        user_id: userIdMail,
        cart_system_id: 2,
      }
    );
  };

  return {
    tryLogin,
    allMenuList,
    planHistory,
    registerInitUser,
    //refCart,
    /*    refOrderLimit,*/
    orderReceive,
    refOnProcessOrders,
    refOrder,
    backendWebSocketDomain,
    refOrderFileName,
    refOrderFileNameOrikomi,
    updateTrackingInfo,
    deleteCart,
    verifyToken,
    refCartGroupBy,
    refCartGroupByOrikomi,
    refOnProcessOrders2dArray,
    refOnProcessOrders2dArrayOrikomi,
    refOrderLimitGroupBy,
    refOrderLimitGroupByOrikomi,
    accountList,
    accountUpdate,
    accountInsert,
    accountDelete,
    myAccountInfo,
    myAccountInfoUpdate,
    myAccountFirstAddressUpdate,
    myAccountPasswordUpdate,
    authorizePlans,
    authorizePlansOrikomi,
    uploadOrderFileOrikomi,
    refOrderOrikomi,

    getRegisterLink,
    registeredCheck,
    payment,
    cancelPayment,
    forgotPassword,
    registerCard,
  };
})();
